import React from 'react'
import PropTypes from 'prop-types'
import HeroSnapshotGenes from './HeroSnapshotGenes'
import HeroSnapshotStatGenes from './HeroSnapshotStatGenes'
//import HeroSnapshotGeneLabels from './HeroSnapshotGeneLabels'
import { GENE_TYPES } from '../../constants/constants'

const HeroSnapshotBack = ({ highlights, hero }) => {
    return (
        <>
            <div className='hero-snapshot-genes-section'>
                {/* <HeroSnapshotGeneLabels /> */}
                <HeroSnapshotGenes genes={hero.mainClassGenes} heroid={hero.id} title='Class' highlighted={highlights.mainClass} />
                <HeroSnapshotGenes genes={hero.subClassGenes} heroid={hero.id} title='SubClass' highlighted={highlights.subClass} hideLabel />
                <HeroSnapshotGenes genes={hero.professionGenes} heroid={hero.id} title='Profession' type={GENE_TYPES.Professions} highlighted={highlights.profession} hideLabel />
            </div>
            <div className='hero-snapshot-stat-genes-section'>
                <HeroSnapshotStatGenes hero={hero} />
            </div>
        </>
    )
}

HeroSnapshotBack.propTypes = {
    highlights: PropTypes.object
}

HeroSnapshotBack.defaultProps = {
    highlights: {}
}

export default HeroSnapshotBack
